import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import SearchComponent from '../../PricingHub/SearchComponent';

class NewSmsReportDataSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'datetime',
      required: true,
      defaultValue: moment(). startOf('month').format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'datetime',
      required: true,
      defaultValue: moment().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.countLimit',
      name: 'countLimit',
      type: 'number',
    },
    {
      label: 'label.amountLimit',
      name: 'amountLimit',
      type: 'number',
    },
  ];

  btnSpan = 'col-md-12';
}

NewSmsReportDataSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

NewSmsReportDataSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(NewSmsReportDataSearchForm);
